export const DEPARTMENT_SCOPED_PERMISSIONS = new Set([
  "view_inventory",
  "view_non_inventory",
  "create_product",
  "update_product",
  "delete_product",
  "view_product",
  "create_account",
  "view_account",
  "create_mrn",
  "update_mrn",
  "delete_mrn",
  "view_mrn",
  "store_keeper_approve_mrn",
  "reject_mrn",
  "complete_mrn",
  "generate_po_by_mrn",
  "cost_review_mrn",
  "complete_quotation_upload_mrn",
  "reopen_quotation_upload_mrn",
  "update_mrn_item_is_proceed",
  "create_mrn_item_remark",
  "create_quotation",
  "update_quotation",
  "delete_quotation",
  "view_quotation",
  "approve_quotation",
  "reject_quotation",
  "complete_quotation",
  "create_quotations",
  "update_quotations",
  "view_quotations",
  "accept_quotations",
  "create_po",
  "update_po",
  "view_po",
  "on_hold_po",
  "reject_po",
  "complete_po",
  "approve_po",
  "place_order_po",
  "generate_grn_by_po",
  "delete_po_item",
  "create_grn",
  "update_grn",
  "view_grn",
  "reject_grn",
  "complete_grn",
  "on_hold_grn",
  "delete_grn_item",
  "create_min",
  "update_min",
  "view_min",
  "reject_min",
  "verify_min",
  "approve_min",
  "issue_min",
  "delete_min",
  "view_foreign_shipment",
  "update_foreign_shipment",
  "update_foreign_shipment_payments",
  "complete_foreign_shipment",
  "cancel_foreign_shipment",
]);

export const isDepartmentScopedPermission = (value) =>
  DEPARTMENT_SCOPED_PERMISSIONS.has(value);

export const permissionsForDepartment = (
  access,
  departmentCode,
  unionPermissions = []
) => {
  const globalOnly = unionPermissions.filter(
    (perm) => !DEPARTMENT_SCOPED_PERMISSIONS.has(perm)
  );
  if (!access || access.unrestricted) {
    return unionPermissions;
  }
  const key = (departmentCode || "").toUpperCase();
  const scoped = access.permissionsByDepartmentCode?.[key];
  if (Array.isArray(scoped)) {
    return [...globalOnly, ...scoped];
  }
  if (access.wildcard) {
    const star = access.permissionsByDepartmentCode?.["*"] || [];
    return [...new Set([...globalOnly, ...star])];
  }
  return [...globalOnly];
};

export const canAccessDepartmentLane = (
  access,
  departmentCode,
  lane,
  unionPermissions = []
) => {
  const perms = permissionsForDepartment(access, departmentCode, unionPermissions);
  const hasInventory = perms.includes("view_inventory");
  const hasNonInventory = perms.includes("view_non_inventory");
  if (hasInventory || hasNonInventory) {
    return lane === "NON_INVENTORY" ? hasNonInventory : hasInventory;
  }
  if (perms.includes("view_product")) {
    return lane !== "NON_INVENTORY";
  }
  return false;
};

export const isAllowedDepartmentQuery = ({
  departmentId,
  departmentAccess,
  departments = [],
  lane,
  unionPermissions = [],
}) => {
  if (departmentId == null) return true;
  if (!departmentAccess) return false;
  if (departmentAccess.unrestricted || departmentAccess.wildcard) return true;
  const dept = departments.find(
    (item) => Number(item.id) === Number(departmentId)
  );
  if (!dept) return false;
  return canAccessDepartmentLane(
    departmentAccess,
    dept.code,
    lane,
    unionPermissions
  );
};
